import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=16b3ddbe&class=fill-height"
import script from "./DeleteClientModal.vue?vue&type=script&lang=ts"
export * from "./DeleteClientModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports